export default "__VITE_ASSET__CZNj$2Lx__"